<template>
    <a href="#" id="back-btn" :class="['btn', 'btn-light', 'btn-icon-left', 'btn-shadow', 'text-uppercase', 'album-action', 'album-action--back-button', {'album-action-is-mobile': isMobile, 'album-action-fullscreen-header': album && album.header_type === 'fullscreen'}]" @click.prevent="goTo()">
        <span class="material-icon icon-keyboard_arrow_left"/>
        <template v-if="!isMobile">
            {{ $t('back') }}
        </template>
    </a>
</template>

<script>
  import backButton from 'src/mixins/backButtonComponent';

  export default {
    mixins: [backButton],
  };
</script>
